import { Button, Icon, Text } from '@inflearn/ds-react';
import { faChevronLeft } from '@inflearn/pro-regular-svg-icons';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

import { MY_URL } from '../../../../constants/urls';

type Props = {
  isWritable?: boolean;
  isLoading: boolean;
};

export default function TopLabel({ isWritable, isLoading }: Props) {
  const { t } = useTranslation();

  if (isLoading) {
    return null;
  }

  return (
    <>
      {!isWritable && (
        <Text component="span" size="sm" color="gray.6">
          {t('강의 노트')}
        </Text>
      )}
      {isWritable && (
        <Button
          component={Link}
          href={MY_URL.NOTES()}
          variant="subtle"
          color="gray"
          size="sm"
          compact
          radius="md"
          leftIcon={<Icon icon={faChevronLeft} size="sm" color="dark" />}
        >
          {t('강의 노트 목록')}
        </Button>
      )}
    </>
  );
}
